"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PendingCardDeletionNotice = PendingCardDeletionNotice;
var _react = _interopRequireDefault(require("react"));
var _elements = require("@reservamos/elements");
var _reactI18next = require("react-i18next");
function PendingCardDeletionNotice(_ref) {
  var onUndo = _ref.onUndo,
    remainingSeconds = _ref.remainingSeconds;
  var _useTranslation = (0, _reactI18next.useTranslation)('purchase'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "rounded-xl bg-gray-50 px-4 py-3",
    role: "status",
    "data-sentry-component": "PendingCardDeletionNotice",
    "data-sentry-source-file": "PendingCardDeletionNotice.tsx"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-end justify-between gap-4"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col gap-1"
  }, /*#__PURE__*/_react["default"].createElement(_elements.Text, {
    size: "M",
    weight: "semibold",
    color: "grayStrong",
    "data-sentry-element": "Text",
    "data-sentry-source-file": "PendingCardDeletionNotice.tsx"
  }, t('saved_card.delete_pending_countdown', {
    seconds: remainingSeconds
  })), /*#__PURE__*/_react["default"].createElement(_elements.Text, {
    size: "S",
    color: "grayMedium",
    "data-sentry-element": "Text",
    "data-sentry-source-file": "PendingCardDeletionNotice.tsx"
  }, t('saved_card.delete_pending_message'))), /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    onClick: onUndo,
    className: "shrink-0 text-base font-semibold text-red-600 underline underline-offset-2"
  }, t('saved_card.delete_undo'))));
}